<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"  >
  <p style="font-size: 20px; color: white">{{'sso.connecting' | translate}}</p>
</ngx-spinner>
<div class="container banner" *ngIf="showForrbidden">
  <div class="jumbotron jumbotron-fluid" style="background-color: #1d81c1">
    <div class="container">
      <h1 class="display-4" style="color:#FFFFFF">{{'sso.forbidden' | translate}}</h1>
      <p class="lead">{{'sso.noAccess' | translate}}</p>
      <p class="lead">{{'sso.contact' | translate}}</p>
    </div>
  </div>
</div>
